import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SastIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Bottom left hexagon */}
    <path
      d="M12.66 18.31V21.49C12.66 21.58 12.64 21.66 12.6 21.73C12.56 21.8 12.5 21.86 12.42 21.91L9.57 23.51C9.42 23.59 9.25 23.59 9.1 23.51L6.25 21.91C6.1 21.83 6.01 21.67 6.01 21.49V18.31C6.01 18.14 6.1 17.98 6.25 17.89L9.1 16.29C9.18 16.25 9.25 16.23 9.33 16.23C9.41 16.23 9.49 16.25 9.57 16.29L12.42 17.89C12.57 17.97 12.66 18.13 12.66 18.31Z"
      fill="#17E88F"
    />

    {/* Bottom right hexagon */}
    <path
      d="M25.99 18.24V21.42C25.99 21.59 25.9 21.75 25.75 21.84L22.9 23.44C22.75 23.52 22.58 23.52 22.43 23.44L19.58 21.84C19.52 21.81 19.47 21.76 19.43 21.71C19.37 21.63 19.34 21.53 19.34 21.42V18.24C19.34 18.07 19.43 17.91 19.58 17.82L22.43 16.22C22.51 16.18 22.59 16.16 22.67 16.16C22.75 16.16 22.82 16.18 22.9 16.22L25.75 17.82C25.9 17.9 25.99 18.06 25.99 18.24Z"
      fill="#17E88F"
    />

    {/* Top hexagon */}
    <path
      d="M19.32 7.08V10.26C19.32 10.35 19.3 10.43 19.26 10.5C19.22 10.58 19.16 10.64 19.08 10.68L16.23 12.28C16.08 12.36 15.91 12.36 15.76 12.28L12.91 10.68C12.84 10.64 12.78 10.58 12.74 10.51C12.69 10.44 12.67 10.35 12.67 10.26V7.08C12.67 6.9 12.76 6.74 12.91 6.66L15.76 5.06C15.91 4.98 16.08 4.98 16.23 5.06L19.08 6.66C19.23 6.75 19.32 6.91 19.32 7.08Z"
      fill="#17E88F"
    />

    {/* Top left hexagon */}
    <path
      d="M12.65 10.83V14.01C12.65 14.18 12.56 14.34 12.41 14.43L9.56 16.03C9.48 16.07 9.41 16.09 9.33 16.09C9.25 16.09 9.17 16.07 9.09 16.03L6.24 14.42C6.09 14.34 6 14.18 6 14V10.82C6 10.65 6.09 10.49 6.24 10.4L9.09 8.81C9.24 8.73 9.41 8.73 9.56 8.81L12.41 10.41C12.48 10.45 12.54 10.51 12.59 10.58C12.63 10.66 12.65 10.74 12.65 10.83Z"
      fill="#17E88F"
    />

    {/* Top right hexagon */}
    <path
      d="M25.99 10.83V14.01C25.99 14.18 25.9 14.34 25.75 14.43L22.9 16.03C22.82 16.07 22.75 16.09 22.67 16.09C22.59 16.09 22.51 16.07 22.43 16.03L19.58 14.43C19.43 14.35 19.34 14.19 19.34 14.01V10.83C19.34 10.74 19.36 10.65 19.4 10.58C19.44 10.51 19.5 10.45 19.57 10.41L22.42 8.81C22.57 8.73 22.74 8.73 22.89 8.81L25.74 10.41C25.89 10.49 25.98 10.65 25.98 10.83H25.99Z"
      fill="#17E88F"
    />

    {/* Bottom center hexagon */}
    <path
      d="M19.32 22.05V25.23C19.32 25.4 19.23 25.56 19.08 25.65L16.23 27.25C16.08 27.33 15.91 27.33 15.76 27.25L12.91 25.65C12.76 25.57 12.67 25.41 12.67 25.23V22.05C12.67 21.96 12.69 21.87 12.74 21.8C12.78 21.73 12.84 21.67 12.91 21.63L15.76 20.03C15.91 19.95 16.08 19.95 16.23 20.03L19.08 21.63C19.16 21.67 19.22 21.73 19.26 21.8C19.3 21.88 19.32 21.96 19.32 22.05Z"
      fill="#17E88F"
    />

    {/* Center connecting piece */}
    <path
      d="M22.16 12.13L19.41 10.58L19.27 10.51L16.5 8.95C16.19 8.78 15.82 8.78 15.52 8.95L12.75 10.51L12.6 10.58L9.85 12.13C9.54 12.3 9.34 12.64 9.34 13V19.31C9.34 19.67 9.53 20 9.85 20.18L12.61 21.73L12.75 21.8L15.52 23.36C15.82 23.53 16.2 23.53 16.5 23.36L19.27 21.81L19.44 21.71L22.17 20.18C22.48 20 22.68 19.67 22.68 19.31V13C22.68 12.64 22.49 12.31 22.17 12.13H22.16Z"
      fill="#0FB870"
    />

    {/* Darker accents */}
    <path
      d="M12.66 18.31V21.49C12.66 21.58 12.64 21.66 12.6 21.73L9.84 20.18C9.52 20 9.33 19.67 9.33 19.31V16.23C9.41 16.23 9.49 16.25 9.57 16.29L12.42 17.89C12.57 17.97 12.66 18.13 12.66 18.31Z"
      fill="#0D9359"
    />
    <path
      d="M12.65 10.83V14.01C12.65 14.18 12.56 14.34 12.41 14.43L9.56 16.03C9.48 16.07 9.41 16.09 9.33 16.09V13C9.33 12.64 9.53 12.3 9.84 12.13L12.59 10.59C12.63 10.66 12.65 10.74 12.65 10.83Z"
      fill="#0D9359"
    />
    <path
      d="M19.26 10.5C19.22 10.58 19.16 10.64 19.08 10.68L16.23 12.28C16.08 12.36 15.91 12.36 15.76 12.28L12.91 10.68C12.84 10.64 12.78 10.58 12.74 10.51L15.51 8.95C15.81 8.78 16.18 8.78 16.49 8.95L19.26 10.5Z"
      fill="#0D9359"
    />
    <path
      d="M22.67 13V16.09C22.59 16.09 22.51 16.07 22.43 16.03L19.58 14.43C19.43 14.35 19.34 14.19 19.34 14.01V10.83C19.34 10.74 19.36 10.65 19.4 10.58L22.15 12.13C22.47 12.31 22.66 12.64 22.66 13H22.67Z"
      fill="#0D9359"
    />
    <path
      d="M22.67 16.16V19.31C22.67 19.67 22.47 20 22.16 20.18L19.43 21.71C19.37 21.63 19.34 21.53 19.34 21.42V18.24C19.34 18.07 19.43 17.91 19.58 17.82L22.43 16.22C22.51 16.18 22.59 16.16 22.67 16.16Z"
      fill="#0D9359"
    />
    <path
      d="M19.26 21.8L16.49 23.36C16.19 23.53 15.81 23.53 15.51 23.36L12.74 21.8C12.78 21.73 12.84 21.67 12.91 21.63L15.76 20.03C15.91 19.95 16.08 19.95 16.23 20.03L19.08 21.63C19.16 21.67 19.22 21.73 19.26 21.8Z"
      fill="#0D9359"
    />
  </SvgIcon>
);

export default SastIcon;
